import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const config = {
    apiKey: "AIzaSyCW2TmnoaOSGjTCkOYGfvIhvmj36_luE8Y",
    authDomain: "meet-status.firebaseapp.com",
    databaseURL: "https://meet-status.firebaseio.com",
    projectId: "meet-status",
    storageBucket: "meet-status.appspot.com",
    messagingSenderId: "764299763861",
    appId: "1:764299763861:web:f17bf6b3c2208d75"
};

export const app = initializeApp(config);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

class Firebase {}
export default Firebase;
